export default {
  isShowLoading(state){
    return state.loadingThreadCount > 0;
  },
  cantDo(state){
    return state.stopDo===true;
  },
  onEvent(state){
    return function(name) {
      let index = state.eventBus.map((eb) => {return eb.name}).indexOf(name);
      if (state.eventBus.length > 0 && index >= 0) {
        let result = Object.assign({}, state.eventBus[index]);
        state.eventBus.splice(index, 1);
        return result;
      }
      return null;
    }
  },
  getCurrentUser(state){
    state.currentUser = state.currentUser.length === 0 ? (sessionStorage.getItem('currentUser') ? sessionStorage.getItem('currentUser') : '') : state.currentUser;
    return JSON.parse(state.currentUser);
  },
  watchWebMessageCountByType(state){
    return function(messageType){
      if(messageType && state.webMessageList.length > 0) {
        return state.webMessageList.filter(wm=>{return wm.messageType === messageType}).length;
      }
      return 0;
    }
  },
  getLatestWebMessageByType(state){
    return function(messageType){
      if(messageType && state.webMessageList.length > 0){
        let index  = state.webMessageList.map(wm=>{return wm.messageType}).indexOf(messageType);
        if(index >= 0){
          let result = Object.assign({}, state.webMessageList[index]);
          state.webMessageList.splice(index, 1);
          return result;
        }
      }
      return null;
    }
  },
  getJobState(state){
    state.jobState = state.jobState === 0 ? (sessionStorage.getItem('jobState') ? sessionStorage.getItem('jobState') : '') : state.jobState;
    return state.jobState;
  },
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js